import { amountOf } from '@/lib/money';

/**
 * CRM-02's one money formatter — whole dollars, thousands separators, no
 * cents, which is the convention the opportunity board and its tiles use.
 *
 * It lives beside the feature rather than in `lib/money` because the "no
 * cents" rule is CRM's alone; every screen elsewhere shows an `Amount`. The
 * SUMS behind it (`sumAmounts` in lib/money) are the shared decimal helpers:
 * the pipeline adds every open deal's value and every weighted value
 * (BR-CRM-02-05: value × probability ÷ 100, so a third of the rows carry a
 * repeating fraction), and adding those as floats drifts exactly where it is
 * most visible — the two headline tiles a sales manager reads before a
 * forecast call.
 */
export function wholeDollars(value: string): string {
  // Rounded HALF-UP through Money (N-6), not Math.round — which would need a
  // float first, and rounds −0.5 the other way.
  const rounded = amountOf(value).rounded().toFixed2();
  /*
   * `Number()` at the very last step, for `toLocaleString`'s digit grouping
   * alone. The value is already a rounded decimal string; nothing is computed
   * from the number, it is only rendered.
   */
  // eslint-disable-next-line money/no-raw-money-arithmetic -- last-step locale grouping, nothing computed
  return `$${Number(rounded).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}
